module.exports = __webpack_public_path__ + "img/ep-login-bg.9dc41bbd.png";